module.exports = __webpack_public_path__ + "img/02.895d29d9.png";